import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { SearchAreaGroupGetResponse } from './search-area-group-get-response';

@Injectable({ providedIn: 'root' })
export class SearchAreaGroupApi {
  constructor(private afs: AngularFirestore) {}

  getAll(): Observable<SearchAreaGroupGetResponse[]> {
    const searchAreasCollection = this.afs.collection<
      SearchAreaGroupGetResponse
    >('search_area_groups', ref => ref.orderBy('index'));

    return searchAreasCollection.valueChanges({ idField: 'id' });
  }
}
